export default {
  pub: {
    pageHeader: {
      demo: '示例',
      userManagement: '示例'

    }
  }
}
